import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'settings-for-extra-features',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './settings-for-extra-features.component.html',
  styleUrl: './settings-for-extra-features.component.scss',
})
export class SettingsForExtraFeaturesComponent {
  availableFeatures = [];
}
